<template>
  <div id="distribuidor d-flex flex-row flex-wrap justify-content-center">
    <Header :home="false" :logged="logged" :arealogada="false" />
    <modaldistribuidordetalhe :reciboDados="resposta" :nrTitulo="resposta.n_titulo" @resposta="respConfirm" />
    <div id="wrapper-spinner" v-if="loading" style="display: block;position: absolute;background: #aaa0a08f;z-index: 100;width: 100%;height: 100%;padding-top: 25%;padding-left: 50%;">
      <BeatLoader color="var(--main-azul)" />
    </div>

    <div id="distribuidor-form">
      <h1 class="mt-3 mb-4"><b>Consulta de Recibos Distribuidor</b></h1>
      <b-card title="" sub-title="" class="mt-3" style="max-width:303px;">
        <b-card-text>
          <h3><b>Olá!</b> <br> Por favor, forneça seu número de recibo e o documento do devedor para que possamos prosseguir com a consulta.</h3>
        </b-card-text>
        <label for="inNrRecibo">
          Digite o Número de Recibo
          <span v-b-popover.hover.top="'Digite atentamente o número do Recibo!.'" title="Recibo">
            <font-awesome-icon icon="info" mask="circle" class="icone" color="blue"/>
          </span>
        </label>
        <b-form-input
          id="inNrRecibo"
          name="inNrRecibo"
          size="lg"
          v-model="nr_recibo"
          class="form-control"
          placeholder="Número de Recibo"
          trim
          @blur.native="valida_formulario"
        ></b-form-input>
        <b-alert :show="validation_nr_recibo === false" variant="danger" class="text-center">Número do Recibo inválido.</b-alert>
        <!-- <label for="input-live">
          <b-form-invalid-feedback :state="validation_nr_recibo">Número do Recibo inválido.</b-form-invalid-feedback>
        </label> -->
        <label for="inDocDevedor">
          Digite o Documento do Devedor
          <span v-b-popover.hover.top="'Digite o documento do Devedor!.'" title="Documento do Devedor">
            <font-awesome-icon icon="info" mask="circle" class="icone" color="blue"/>
          </span>
        </label>
        <the-mask
          :mask="['###.###.###-##', '##.###.###/####-##']"
          id="inDocDevedor"
          name="inDocDevedor"
          v-model="doc_devedor"
          class="form-control form-control-lg"
          placeholder="CPF ou CNPJ"
          @blur.native="valida_formulario"
        />
        <b-alert :show="validation_documento_devedor === false" fade variant="danger" class="text-center">Documento do devedor inválido.</b-alert>
        <!-- <label for="input-live">
          <b-form-invalid-feedback :state="validation_documento_devedor">Documento do devedor inválido.</b-form-invalid-feedback>
        </label> -->
        <b-button block id="bt-consultar" class="text-center" @click="consultar()">Consultar</b-button>
      </b-card>
      <vue-recaptcha
        ref="invisibleRecaptcha"
        @verify="onVerify"
        @expired="onExpired"
        size="invisible"
        :sitekey="sitekey"
      ></vue-recaptcha>
    </div>
    <footersite class="d-none d-xl-block" />
    <footersitemobile class="d-block d-xl-none" />
  </div>
</template>

<script>
import API from "../services/api";
import BeatLoader from "vue-spinner/src/BeatLoader.vue";
import VueRecaptcha from "vue-recaptcha";
import { TheMask } from "vue-the-mask";
import Serv from "../services";
import modaldistribuidordetalhe from "@/components/modal/distribuidor_detalhe";
import Header from "../components/Header";
import footersite from "@/components/footersite";
import footersitemobile from "@/components/footersite/index_mobile";

export default {
  components: {
    BeatLoader,
    VueRecaptcha,
    TheMask,
    Header,
    footersite,
    footersitemobile,
    modaldistribuidordetalhe,
  },
  data() {
    return {
      sitekey: process.env.VUE_APP_sitekeyRecaptchaInvisivel,
      logged: false,
      nr_recibo: "",
      doc_devedor: "",
      tok: "",
      loading: false,
      pdf_boleto: "",
      pdf_Relatorio: "",
      chave: "",
      resposta: {
        chave_unica: "",
        n_protocolo: "",
        data_protocolo: "",
        cod_cartorio: "",
        nome_cartorio: "",
        n_titulo: "",
        data_remessa: "",
        portador: "",
        nosso_numero: "",
        sacador: "",
        cnpj_sacador: "",
        pagador: "",
        uf_cartorio: "",
        comarca_cartorio: "",
        endereco_cartorio: "",
        cnpj_pagador: "",
        nr_recibo: "",
        cd_ibge: "",
        cartorio_telefone: "",
        cartorio_hora_funcionamento: "",
      },
      validation_nr_recibo: null,
      validation_documento_devedor: null,
    };
  },
  mounted() {
    this.$root.isLogged().then(() => {
      this.logged = true;
    })
    .catch(() => {
      this.logged = false;
    });
  },
  methods: {
    respConfirm(res) {
      if (res.respostaFinal == "s") {
        this.$bvModal.hide("modal-distribuidor-detalhe");
      }
    },
    valida_formulario() {
      this.validation_nr_recibo = this.nr_recibo.length >= 1

      if (this.doc_devedor.length){
        let documento = this.doc_devedor.replace(/\D/, "");
        if (documento.length > 11) {
          // console.log('CNPJ')
          // console.log("retorno = " + !Serv.validarCNPJ(documento))
          this.validation_documento_devedor = Serv.validarCNPJ(documento)
        } else {
          // console.log('CPF')
          // console.log(!Serv.validarCPF(documento))
          this.validation_documento_devedor = Serv.validarCPF(documento)
        }
      }
    },
    onVerify: function(response) {
      this.tok = response;
      this.$refs.invisibleRecaptcha.reset();
      this.valida_formulario();
      if (this.doc_devedor && this.nr_recibo) {
        this.loading = true;

        // Parâmetros a serem enviados
        const data = {
          nr_recibo: this.nr_recibo,
          documento_devedor: this.doc_devedor,
        };

        if (this.validation_documento_devedor && this.validation_nr_recibo) {
          API.post("/distribuidor/consulta_recibo", data).then((res) => {
            if (res.data.status == 200) {
              let resposta_interna = res.data.data;

              this.resposta.chave_unica       = resposta_interna.cd_chave_unica;
              this.resposta.n_protocolo       = resposta_interna.nm_nr_protocolo;
              this.resposta.data_protocolo    = resposta_interna.dt_protocolo;
              this.resposta.cod_cartorio      = resposta_interna.nm_nr_cartorio;
              this.resposta.nome_cartorio     = resposta_interna.nm_cartorio;
              this.resposta.uf_cartorio       = resposta_interna.uf;
              this.resposta.comarca_cartorio  = resposta_interna.cidade;
              this.resposta.endereco_cartorio = resposta_interna.endereco + " " + resposta_interna.endereco_numero + " " + resposta_interna.complemento;
              this.resposta.cd_ibge           = resposta_interna.codigo_abrancia;
              this.resposta.cartorio_telefone = resposta_interna.telefone;
              this.resposta.nr_recibo         = resposta_interna.nr_recibo;
              this.resposta.cartorio_hora_funcionamento = resposta_interna.hora_funcionamento;

              this.resposta.n_titulo     = resposta_interna.nm_nr_titulo;
              this.resposta.data_remessa = resposta_interna.dt_movimento_h;
              this.resposta.portador     = resposta_interna.nm_portador_h;
              this.resposta.nosso_numero = resposta_interna.nm_nosso_numero;

              this.resposta.sacador      = resposta_interna.nm_sacador;
              this.resposta.cnpj_sacador = resposta_interna.anonimizar_nr_documento_sacador;

              this.resposta.pagador      = resposta_interna.nm_devedor;
              this.resposta.cnpj_pagador = resposta_interna.anonimizar_nr_identificacao_devedor;

              this.$bvModal.show("modal-distribuidor-detalhe");
            }
            if (res.data.status == 404)  alert("Não encontramos nenhum registro que corresponda à sua pesquisa.");
          }).catch(() => {
            this.loading = false;
          });
          this.loading = false;
          this.nr_recibo = "";
          this.doc_devedor = "";
        }
        this.loading = false;
      }
    },
    onExpired: function() {
      this.$refs.invisibleRecaptcha.reset();
    },
    resetRecaptcha() {
      this.$refs.invisibleRecaptcha.reset();
    },
    consultar() {
      this.valida_formulario();
      this.$refs.invisibleRecaptcha.execute();
    },
  },
};
</script>

<style scoped>
h1 {
  text-align: center;
  font: normal normal bold 25px/30px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #597eb5;
  margin-bottom: 18px;
}
h3 {
  text-align: center;
  font: normal normal normal 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #597eb5;
  margin-bottom: 50px;
}
label {
  text-align: left;
  font: normal normal normal 15px/20px 'Kanit', sans-serif !important;
  letter-spacing: 0px !important;
  color: #597eb5 !important;
  margin-bottom: 5px;
  margin-left: 0.75rem;
  width: 100%;
}
#distribuidor-form {
  margin-top: calc(80px + 40px);
  padding-top: 40px;
  display:flex;
  align-items:center;
  flex-flow:column;
}
input {
  color: #495057;
  background: #F1F1F1 0% 0% no-repeat padding-box;
  padding: 0.375rem 0.75rem;
  border: 1px solid #FFFFFF;
  border-radius: 5px;
  text-align: left;
  font: normal normal normal 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  height: 35px;
  margin-bottom: 13px;
}
.alert-danger{
  background: #F8CBCB 0% 0% no-repeat padding-box;
  color: #702727;
  font: normal normal bold 15px/20px 'Kanit', sans-serif !important;
  letter-spacing: 0px;
  margin-bottom: 20px;
}

#bt-consultar {
  width: 100%;
  margin-top: 40px;
  height: 44px;
  background: #1aceb5 0% 0% no-repeat padding-box;
  font: normal normal bold 15px/15px 'Kanit', sans-serif;
  border-radius: 5px;
  opacity: 1;
  border: none;
  outline: none;
}
#bt-consultar:disabled {
  background: #1aceb55c 0% 0% no-repeat padding-box;
}
#bt-consultar:active,
#bt-consultar:focus {
  background: #1aceb5 0% 0% no-repeat padding-box;
  box-shadow: none;
  border: none;
  outline: none;
}
html {
  overflow: hidden !important;
}
.icone {
  font-size: 16px;
  margin-top: 10px;
}
.label-style {
  text-align: left !important;
  display: block;
  font-size: 20px;
  font-weight: bold;
}

.input-style {
  background-color: transparent !important;
  padding: 0 !important;
  border-radius: 0px !important;
  box-shadow: none !important;
}

.fixed-height {
  height: 30px;
}
</style>
